<div class="badge-description text-center rounded-lg px-2 py-1 leading-tight" [ngClass]="[badgeClass ?? '', textClass || 'text-xxs']" [class.w-full]="fullWidth" [class.truncate]="truncate">
  {{ badgeData?.description | transloco }}
</div>
